import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {UserNameValidationService} from '../../services/user-registration/user-name-validation.service';
import {first, map} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {UserAccountFacade} from '@spartacus/user/account/root';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ValidUserNameGuard  {

  constructor(
    private userAccountFacade: UserAccountFacade,
    private userNameValidationService: UserNameValidationService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userAccountFacade.get().pipe(
      first(),
      map(user => {
        if (this.userNameValidationService.isUserNameValid(user) || this.userNameValidationService.getCorrectedUserName()) {
          return true;
        } else {
          this.router.navigateByUrl('/selectionType');
          return false;
        }
      }), untilDestroyed(this));
  }
}
